/**
 * @internal
 */
export const maxUint96 = 2n ** 96n - 1n;
//# sourceMappingURL=types.js.map